<template>
  <div class="IoTRulesTable">
    <div class="text-danger" v-if="errorOnIoTRule">
      {{ errorOnIoTRule }}
    </div>
    <v-data-table
      density="compact"
      :headers="headers"
      :items="rules"
      :loading="waitingForServiceCall"
      loading-text="Loading... Please wait"
      :sort-by="[{ key: 'chip', order: 'asc' }]"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>IoT Shadow Named Rules</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="900px">
            <template v-slot:activator="{ props }">
              <v-btn color="primary" class="mb-2" v-bind="props">
                Add New Rule
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        name="ChipField"
                        v-model="editedItem.chip"
                        label="Chip"
                        v-bind:disabled="inEdit"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        name="MinFWField"
                        v-model="editedItem.minFirmware"
                        label="Min FW"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        name="MaxFWField"
                        v-model="editedItem.maxFirmware"
                        label="Max FW"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        name="SOCField"
                        v-model="editedItem.soc"
                        label="SOC"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        name="ModelYearField"
                        v-model="editedItem.modelYear"
                        label="Model Year"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        name="ModelNumberField"
                        v-model="editedItem.modelNumber"
                        label="Model Number"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        name="RolloutPercentageField"
                        v-model="editedItem.rolloutPercentage"
                        label="Rollout Percentage Year"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        name="ESNRecordsField"
                        v-model="editedItem.ESNRecords"
                        label="ESN Records"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                        label="Shadow Payload"
                        v-model="editedItem.shadowPayload"
                        @input="jsonValidator(editedItem)"
                        name="ShadowPayload"
                      ></v-textarea>
                      <div class="text-danger" v-if="jsonError">
                        {{ jsonError }}
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-checkbox
                        name="EnabledCheckbox"
                        v-model="editedItem.enabled"
                        label="Enabled"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue-darken-1" variant="text" @click="close">
                  Cancel
                </v-btn>
                <v-btn
                  color="blue-darken-1"
                  variant="text"
                  :loading="waitingForServiceCall"
                  :disabled="waitingForServiceCall"
                  @click="save"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >Are you sure you want to delete this item?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="DeleteCancel"
                  color="blue-darken-1"
                  variant="text"
                  @click="close"
                  >Cancel</v-btn
                >
                <v-btn
                  class="DeleteConfirm"
                  color="blue-darken-1"
                  variant="text"
                  @click="deleteItemConfirm"
                  :loading="waitingForServiceCall"
                  :disabled="waitingForServiceCall"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small name="EditRow" class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small name="DeleteRow" @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:[`item.enabled`]="{ item }">
        <v-checkbox :disabled="true" :model-value="item.enabled"> </v-checkbox>
      </template>
      <template v-slot:no-data>No rules in this table</template>
    </v-data-table>
  </div>
</template>

<script>
import { store } from "../store/index";
const headers = [
  { title: "Enabled", align: "start", key: "enabled" },
  { title: "Chip", key: "chip" },
  { title: "Min FW", key: "minFirmware" },
  { title: "Max FW", key: "maxFirmware" },
  { title: "SOC", key: "soc" },
  { title: "Model Year", key: "modelYear" },
  { title: "Model Number", key: "modelNumber" },
  { title: "ESN Records", key: "ESNRecords" },
  { title: "Actions", key: "actions", sortable: false },
];

export default {
  data: () => ({
    headers: headers,
    jsonError: "",
    editedItem: {
      chip: "",
      uuid: "-1",
      soc: "",
      minFirmware: "",
      maxFirmware: "",
      model_name: "",
      model_year: "",
      model_number: "",
      rollout_percentage: "",
      ESNRecords: [],
      shadowPayload: JSON.stringify({}),
      enabled: false,
    },
    defaultItem: {
      chip: "",
      uuid: "-1",
      soc: "",
      minFirmware: "",
      maxFirmware: "",
      model_name: "",
      model_year: "",
      model_number: "",
      rollout_percentage: "",
      ESNRecords: [],
      shadowPayload: JSON.stringify({}),
      enabled: false,
    },
    dialog: false,
    dialogDelete: false,
    inEdit: false,
    editedIndex: -1,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Rule" : "Edit Rule";
    },
    waitingForServiceCall() {
      return this.$store.state.waitingForServiceCall;
    },
    errorOnIoTRule() {
      return this.$store.state.errorOnIoTRule;
    },
    rules() {
      return store.state.iotRules;
    },
  },
  watch: {
    waitingForServiceCall(val) {
      val || this.tableChangeCleanup();
    },
  },
  created() {
    this.fetchIoTRules();
  },
  methods: {
    jsonValidator(rule) {
      this.jsonError = "";
      try {
        JSON.parse(rule.shadowPayload);
      } catch (error) {
        this.jsonError = JSON.stringify(error.message);
      }
    },
    editItem(item) {
      this.inEdit = true;
      this.editedIndex = this.rules.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.rules.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.deleteIoTRule(this.rules[this.editedIndex]);
    },
    tableChangeCleanup() {
      this.close();
      this.fetchIoTRules();
    },
    save() {
      if (this.inEdit) {
        this.updateRule(this.editedItem);
      } else {
        this.addRule(this.editedItem);
      }
    },

    close() {
      this.dialog = false;
      this.inEdit = false;
      this.editedItem = this.defaultItem;
      this.dialogDelete = false;
    },

    fetchIoTRules() {
      store.dispatch("FETCH_IOT_RULES", { router: this.$router });
    },

    _castESNRecords(ESNRecords) {
      return Array.isArray(ESNRecords) ? ESNRecords : ESNRecords.split(",");
    },
    addRule(newAddRule) {
      const date = new Date();
      const utcTime = date.toUTCString();
      let newUUID = (
        utcTime.substring(5, utcTime.length - 4) +
        ":" +
        date.getUTCMilliseconds()
      ).replaceAll(" ", "-");

      //uuid will be in the form 'DD-MMM-YYYY-HH:MM:SS:MS'
      newAddRule.uuid = newUUID;

      // ESNRecord convert to array
      newAddRule.ESNRecords = this._castESNRecords(newAddRule.ESNRecords);

      store.dispatch("ADD_IOT_RULE", newAddRule);
    },
    updateRule(updateRule) {
      // ESNRecord convert to array
      updateRule.ESNRecords = this._castESNRecords(updateRule.ESNRecords);
      store.dispatch("UPDATE_IOT_RULE", updateRule);
    },
    deleteIoTRule(deleteIoTRule) {
      store.dispatch("DELETE_IOT_RULE", deleteIoTRule);
    },
  },
};
</script>
<style scoped>
.text-danger {
  background-color: #fff;
  color: red;
}
</style>
